import { render } from "./Article.vue?vue&type=template&id=449fca1c"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
script.render = render

export default script